import { formatPrice } from 'utils/helpers/functions/formatPrice';
import { safeFloatParse } from 'utils/helpers/safeParsing';
import {
    getBaseCurrencyPrefix,
    getIsLocalCurrencyMode,
    getLocalCurrencyPrefix,
    getPrimaryCurrencyPrefix,
} from 'utils/helpers/currency/currencyHelpers';

export interface DualPriceRow {
    priceSale?: number | null;
    price?: number | null;
}

export const getFmtRate = (rate: number) => (Number.isFinite(rate) && rate > 0 ? rate : 1);

export const getSaleUsd = (row: DualPriceRow) => safeFloatParse(row.priceSale ?? row.price ?? 0) || 0;

export const calcSaleRate = (saleUsd: number, rate: number) =>
    safeFloatParse(saleUsd * getFmtRate(rate)) || 0;

export const calcUsdFromRate = (saleRate: number, rate: number) =>
    safeFloatParse(saleRate / getFmtRate(rate)) || 0;

export const saleUsdFromEditValue = (value: string | number, rate: number, editRatePrice: boolean) => {
    const amount = safeFloatParse(value || 0) || 0;
    return editRatePrice ? calcUsdFromRate(amount, rate) : amount;
};

export const getPriceEditDefaultValue = (row: DualPriceRow, rate: number, editRatePrice: boolean) => {
    const saleUsd = getSaleUsd(row);
    return editRatePrice ? calcSaleRate(saleUsd, rate) : saleUsd;
};

export const getPriceEditPrefix = (rate: number, editRatePrice: boolean) =>
    editRatePrice ? getLocalCurrencyPrefix() : getPrimaryCurrencyPrefix(rate);

export const formatPrimaryPrice = (amount: number, rate: number) => {
    const prefix = getIsLocalCurrencyMode(rate) ? getLocalCurrencyPrefix() : getBaseCurrencyPrefix();
    return `${prefix}${formatPrice(amount)}`;
};

export const shouldShowRateLine = (rate: number) => !getIsLocalCurrencyMode(rate);

export const formatRateLine = (saleUsd: number, rate: number) =>
    `${getLocalCurrencyPrefix()}${formatPrice(calcSaleRate(saleUsd, rate))}`;
